export default [
  {
    path: '/bases',
    name: 'Bases',
    component: () => import(/* webpackChunkName: "Bases" */ '../bases/Bases')
  },
  {
    path: '/bases-cadastro',
    name: 'BasesCadastro',
    component: () => import(/* webpackChunkName: "BasesCadastro" */ '../bases/BasesCadastro')
  },
  {
    path: '/bases-lista',
    name: 'BasesListas',
    component: () => import(/* webpackChunkName: "BasesListas" */ '../bases/BasesLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/configuracoes/bases/router.js